import React from 'react';

export const AboutPage: React.FC = () => {
  return (
    <div className="h-full w-full p-6 overflow-y-auto">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">About Urban Forestry Platform</h1>
          <p className="text-xl text-gray-600">
            A comprehensive tool for urban tree planting and forest management in Hackensack, New Jersey.
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2">
          <div className="card">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Our Mission</h2>
            <p className="text-gray-600 mb-4">
              To enhance urban sustainability and community well-being through strategic tree planting 
              and forest management, using data-driven insights to create greener, healthier neighborhoods.
            </p>
            <p className="text-gray-600">
              We combine environmental science, community engagement, and modern technology to make 
              urban forestry accessible and effective for everyone.
            </p>
          </div>

          <div className="card">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Key Features</h2>
            <ul className="space-y-2 text-gray-600">
              <li className="flex items-start">
                <span className="text-forest-600 mr-2">•</span>
                Interactive mapping with environmental data layers
              </li>
              <li className="flex items-start">
                <span className="text-forest-600 mr-2">•</span>
                Site assessment tool for optimal tree placement
              </li>
              <li className="flex items-start">
                <span className="text-forest-600 mr-2">•</span>
                Comprehensive tree species database
              </li>
              <li className="flex items-start">
                <span className="text-forest-600 mr-2">•</span>
                Community engagement and suggestion platform
              </li>
            </ul>
          </div>

          <div className="card">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Environmental Impact</h2>
            <p className="text-gray-600 mb-4">
              Urban trees provide numerous environmental benefits including:
            </p>
            <ul className="space-y-2 text-gray-600">
              <li className="flex items-start">
                <span className="text-forest-600 mr-2">•</span>
                Carbon sequestration and air quality improvement
              </li>
              <li className="flex items-start">
                <span className="text-forest-600 mr-2">•</span>
                Stormwater management and flood reduction
              </li>
              <li className="flex items-start">
                <span className="text-forest-600 mr-2">•</span>
                Urban heat island mitigation
              </li>
              <li className="flex items-start">
                <span className="text-forest-600 mr-2">•</span>
                Biodiversity enhancement and habitat creation
              </li>
            </ul>
          </div>

          <div className="card">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Technology Stack</h2>
            <p className="text-gray-600 mb-4">
              Built with modern web technologies for performance and accessibility:
            </p>
            <ul className="space-y-2 text-gray-600">
              <li className="flex items-start">
                <span className="text-forest-600 mr-2">•</span>
                React 18 with TypeScript for robust frontend development
              </li>
              <li className="flex items-start">
                <span className="text-forest-600 mr-2">•</span>
                MapLibre GL JS for interactive mapping
              </li>
              <li className="flex items-start">
                <span className="text-forest-600 mr-2">•</span>
                Node.js API with PostgreSQL database
              </li>
              <li className="flex items-start">
                <span className="text-forest-600 mr-2">•</span>
                Tailwind CSS for responsive design
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 card">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">Get Involved</h2>
          <p className="text-gray-600 mb-4">
            Urban forestry is a community effort. Here's how you can contribute:
          </p>
          <div className="grid gap-4 md:grid-cols-3">
            <div className="text-center p-4 bg-forest-50 rounded-lg">
              <h3 className="font-semibold text-forest-800 mb-2">Suggest Locations</h3>
              <p className="text-sm text-forest-600">
                Use our community portal to suggest new tree planting locations
              </p>
            </div>
            <div className="text-center p-4 bg-forest-50 rounded-lg">
              <h3 className="font-semibold text-forest-800 mb-2">Assess Sites</h3>
              <p className="text-sm text-forest-600">
                Help evaluate potential planting sites using our assessment tool
              </p>
            </div>
            <div className="text-center p-4 bg-forest-50 rounded-lg">
              <h3 className="font-semibold text-forest-800 mb-2">Share Knowledge</h3>
              <p className="text-sm text-forest-600">
                Contribute local knowledge about tree species and growing conditions
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
